import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let URL = "https://benefacto-backend.developer-ourbase-camp.com/api/";

export const policyApi = createAsyncThunk("policy/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}pages/showPage`);
		return data;
	} catch (err) {
		return err.message;
	}
});
